import React from 'react';
import ImagePlaceholder from './ImagePlaceholder';
import useFadeIn from './useFadeIn';

const occasions = [
  {
    icon: '💍',
    title: 'Ślub',
    desc: 'Efektowny wjazd do kościoła lub urzędu. Niezapomniane wspomnienia dla Pary Młodej.',
    img: 'Infiniti FX35 na ślubie&#10;(occasion-wedding.jpg)',
  },
  {
    icon: '📸',
    title: 'Sesja zdjęciowa',
    desc: 'Jasne wnętrze i efektowna sylwetka tworzą idealne tło do każdego ujęcia.',
    img: 'Infiniti FX35 – sesja zdjęciowa&#10;(occasion-photo.jpg)',
  },
  {
    icon: '🎉',
    title: 'Event',
    desc: 'Przyjedź na każde wydarzenie z klasą. FX35 wyróżni Cię w każdym towarzystwie.',
    img: 'Infiniti FX35 na evencie&#10;(occasion-event.jpg)',
  },
  {
    icon: '🥂',
    title: 'Rocznica',
    desc: 'Odnów przysięgę miłości i celebruj wyjątkowe chwile w luksusowym otoczeniu.',
    img: 'Infiniti FX35 – rocznica&#10;(occasion-anniversary.jpg)',
  },
  {
    icon: '👑',
    title: 'Wieczór pań / kawalerów',
    desc: 'Zacznij nowy rozdział z przytupem. Stylowy transport dla całej grupy.',
    img: 'Infiniti FX35 – wieczór panieński&#10;(occasion-bachelorette.jpg)',
  },
  {
    icon: '🚘',
    title: 'Przejazd VIP',
    desc: 'Prestiżowy transport dla wyjątkowych gości. Dyskrecja i klasa w każdym detalu.',
    img: 'Infiniti FX35 – VIP&#10;(occasion-vip.jpg)',
  },
];

export default function Occasions() {
  const titleRef = useFadeIn();

  return (
    <section
      id="occasions"
      style={{
        padding: '120px 24px',
        background: 'linear-gradient(180deg, #050a1a 0%, #0a1628 50%, #050a1a 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: 600,
          height: 600,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.06) 0%, transparent 70%)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div ref={titleRef} className="fade-in-section" style={{ textAlign: 'center', marginBottom: 72 }}>
          <p className="section-label" style={{ marginBottom: 16 }}>Zastosowanie</p>
          <h2 className="section-title">
            Idealny na{' '}
            <span
              style={{
                fontStyle: 'italic',
                background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              wyjątkowe okazje
            </span>
          </h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: 20,
          }}
        >
          {occasions.map((occ, i) => (
            <OccasionCard key={occ.title} {...occ} delay={i * 70} />
          ))}
        </div>

        <div
          style={{
            textAlign: 'center',
            marginTop: 60,
            padding: '32px 40px',
            borderRadius: 16,
            border: '1px solid rgba(59,130,246,0.15)',
            background: 'rgba(10,22,40,0.5)',
            backdropFilter: 'blur(12px)',
            maxWidth: 640,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <p style={{ fontSize: 14, color: 'rgba(244,245,247,0.6)', lineHeight: 1.7 }}>
            <span style={{ color: '#3b82f6', fontWeight: 500 }}>Oferta ustalana indywidualnie</span> w zależności
            od terminu, trasy i czasu wynajmu. Skontaktuj się z nami, aby omówić szczegóły.
          </p>
        </div>
      </div>
    </section>
  );
}

function OccasionCard({ icon, title, desc, img, delay }) {
  const ref = useFadeIn();

  return (
    <div
      ref={ref}
      className="fade-in-section"
      style={{
        borderRadius: 16,
        overflow: 'hidden',
        border: '1px solid rgba(59,130,246,0.1)',
        background: 'rgba(10,22,40,0.4)',
        transition: 'all 0.35s ease',
        cursor: 'default',
        transitionDelay: `${delay}ms`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.3)';
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = '0 24px 60px rgba(0,0,0,0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.1)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/*
        PODMIEŃ ZDJĘCIA:
        Umieść pliki w /public/images/ (nazwa w nawiasie w propsie img)
        i zamień <ImagePlaceholder> na <img src="/images/<nazwa>" alt={title} style={{width:'100%', height:'180px', objectFit:'cover'}} />
      */}
      <div style={{ overflow: 'hidden' }}>
        <ImagePlaceholder label={img} aspectRatio="16/9" />
      </div>

      <div style={{ padding: '20px 20px 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <span style={{ fontSize: 22 }}>{icon}</span>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: '#f4f5f7' }}>{title}</h3>
        </div>
        <p style={{ fontSize: 13, color: 'rgba(244,245,247,0.5)', lineHeight: 1.65 }}>{desc}</p>
      </div>
    </div>
  );
}
